import { ShieldAlert, ShieldCheck } from "lucide-react";

export default function SecurityPanel({ security }) {
  if (!security) return null;
  const active = security.dev_code_active;
  const Icon = active ? ShieldAlert : ShieldCheck;
  return (
    <div className={`surface p-4 ${active ? "border-amber-500/50" : "border-emerald-500/40"}`} data-testid="security-panel">
      <div className="flex items-center gap-2 text-sm font-bold"><Icon className={`h-4 w-4 ${active ? "text-amber-500" : "text-emerald-500"}`} /> Sign-in security</div>
      <dl className="mt-2 grid gap-1 text-xs sm:grid-cols-[160px_1fr]">
        <dt className="text-muted-foreground">Public URL</dt>
        <dd className="mono break-all" data-testid="security-public-url">{security.public_url || "— not set (APP_PUBLIC_URL)"}</dd>
        <dt className="text-muted-foreground">Dev sign-in code</dt>
        <dd data-testid="security-dev-code">
          {active ? <span className="font-semibold text-amber-500">ACTIVE — preview only. Any user can sign in with the universal code.</span>
            : security.dev_code_configured ? <span className="text-emerald-500">Disabled (configured, but inert because the public URL is not a preview host)</span>
            : <span className="text-emerald-500">Disabled (not configured)</span>}
        </dd>
      </dl>
      {active && <p className="mt-2 text-[11px] text-muted-foreground">For production: set <span className="mono">APP_PUBLIC_URL</span> to your real domain and clear <span className="mono">AUTH_DEV_CODE</span> in the deployment secrets, then re-publish. This panel turns green when it is safe.</p>}
    </div>
  );
}
